export default "__VITE_ASSET__Cu8AgUGE__"